import * as types from "../../actions/ActionTypes";

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const getPaymentHistoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_PAYMENT_HISTORY_START:
      return { ...state, loading: true, error: null };
    case types.GET_PAYMENT_HISTORY_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case types.GET_PAYMENT_HISTORY_ERROR:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default getPaymentHistoryReducer;
